import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Styled from 'features/ShoppingCart/utils/styles';
import { PaymentError } from 'features/ShoppingCart/components/PaymentError';
import {
  lastNameValidation,
  memberNumberValidation,
} from 'features/ShoppingCart/utils/validate';
import { FieldName } from 'features/ShoppingCart/types';
import TextFieldInput from 'components/common/TextFieldInput/TextFieldInput';

const MemberChargePayment = () => {
  const {
    unregister,
    formState: { errors },
  } = useFormContext();
  const { t: translateText } = useTranslation();

  useEffect(() => {
    return () => {
      // we need to unregister these fields when the payment method
      // unmounts, otherwise the validations specific to this payment
      // method will be applied to other payment methods
      unregister([FieldName.PAYMENT_NAME, FieldName.RESERVATION_NUMBER], {
        keepDefaultValue: true,
        keepValue: true,
      });
    };
  }, []);

  return (
    <>
      <Styled.AccordionContent>
        <span>{translateText('requiredFieldIndicator')}</span>
        <Styled.InputWrapper>
          <TextFieldInput
            name={FieldName.PAYMENT_NAME}
            label={translateText(FieldName.LAST_NAME)}
            rules={{ ...lastNameValidation }}
            required
            autoComplete="family-name"
            placeholder={translateText(FieldName.LAST_NAME)}
          />
          <TextFieldInput
            name={FieldName.RESERVATION_NUMBER}
            label={translateText('memberNumber')}
            rules={{ ...memberNumberValidation }}
            required
            autoComplete="off"
            placeholder={translateText('memberNumber')}
          />
        </Styled.InputWrapper>
      </Styled.AccordionContent>
      <PaymentError
        error={
          (errors.paymentName?.message ||
            errors.reservationNumber?.message) as string
        }
      />
    </>
  );
};

export default MemberChargePayment;
